import { IMessageListItemV2 } from '../repositories/chats/entities/message_list_item_v2/MessageListItemV2';
import { TMessageSchema } from '../types/messages';

export const mapMessage = (message: IMessageListItemV2): TMessageSchema => {
  return {
    ...message,
    unread: message.status !== 'readByRecipient' && message.status !== 'deleted',
    type: message.type,
  };
};
